import React from 'react';
import AuthCardLayout from './authentication/AuthCardLayout';
import ForgetPasswordForm from './authentication/ForgetPasswordForm';

function ForgetPassword() {
  return (
    <AuthCardLayout>
      <h4 className="mb-0"> Забули свій пароль?</h4>
      <p />
      <p className="mb-0">Введіть свою електронну адресу, і ми надішлемо вам посилання для нового паролю.</p>
      <ForgetPasswordForm layout="card" />
    </AuthCardLayout>
  );
}

export default ForgetPassword;
